const thoughts = [
  // {
  //   slug: "the-new-edge-is-selection",
  //   title: "The New Edge Is Selection",
  //   description:
  //     "As AI makes production abundant, the advantage shifts from execution speed to choosing what is worth building.",
  //   excerpt:
  //     "AI makes it easier to generate ideas, campaigns and implementation paths. The real advantage is knowing which one deserves to exist.",
  //   date: "2026-08-07",
  //   image: null,
  //   body: [
  //     "AI is making production abundant. The scarce skill is becoming selection.",
  //     "When a team can generate ten product ideas, ten campaigns or ten implementation paths in a fraction of the time, the advantage is no longer just execution speed. It is knowing which one deserves to exist.",
  //     "That is where founders, product leaders and experienced builders matter most: setting direction, recognising signal, and deciding what not to build.",
  //   ],
  // },
  {
    slug: "quality-is-visible-in-recovery",
    title: "Quality Is Visible in Recovery",
    description:
      "A product's real quality is revealed not by its successful flows, but by how safely and clearly it handles interruption and failure.",
    excerpt:
      "The best products do not pretend failures never happen. They make the next step obvious without passing confusion or risk to the customer.",
    date: "2026-08-20",
    image: null,
    body: [
      "The quality of a product is most visible in how it recovers.",
      "A successful transaction proves the happy path works. A failed payment, duplicate request, or interrupted update reveals whether the product was built with discipline.",
      "Recovery is not just an engineering concern; it is a business decision. Clear states, safe retries, and honest communication protect trust when certainty is unavailable.",
      "In my view, recovery is often a stronger sign of product maturity than feature count. The best products do not pretend failures never happen. They make the next step obvious - and avoid passing confusion or risk to the customer.",
    ],
  },
  {
    slug: "a-convincing-prototype-a-dangerous-milestone",
    title: "A Convincing Prototype Can Be a Dangerous Milestone",
    description:
      "The closer a prototype looks to a finished product, the easier it becomes to underestimate the engineering and operational work still missing.",
    excerpt:
      "Visual progress can create business commitment faster than the underlying product earns it.",
    date: "2026-08-12",
    image: null,
    body: [
      "Modern tools can turn an idea into something remarkably convincing, remarkably quickly. That is progress, which can create a false sense of proximity to a finished product.",
      "Once a prototype looks complete, timelines, budgets and customer commitments begin forming around its polish rather than its readiness. Visual progress can create business commitment faster than the product earns it.",
      "A prototype proves the intended journey can work. A product must remain secure, reliable and supportable when it does not. The more convincing the prototype, the more disciplined the evaluation behind it should be.",
    ],
  },
  {
    slug: "the-new-edge-is-selection",
    title: "The New Edge Is Selection",
    description:
      "As AI advances and makes production abundant, the real advantage shifts from speed of execution to identifying what is worth executing.",
    excerpt:
      "AI makes it easier to generate ideas, campaigns and implementation paths. The real advantage is knowing which one deserves to exist.",
    date: "2026-08-07",
    image: null,
    body: [
      "The scarce skill is not production anymore, it is selection.",
      "When an individual or a team can generate multiple implementations in a fraction of time required previously for a single implementation, the advantage is no longer just the quantity achieved from the increased speed of execution. It becomes a matter of prioritizing and choosing where to channel the energy.",
      "That is where founders, product leaders and experienced builders matter most: setting the direction, recognising signal, and diligently deciding what not to build.",
    ],
  },
]

module.exports = thoughts
